import { adaptRequestResponse } from '@api/adapters/requestResponse';
import { useGetUserQuery } from '@api/services';

import type { RequestResponse } from '@api/services/types/RequestStatus';
import type { User } from '@api/types';

const useUserQuery = (): RequestResponse<User> => {
  const { currentData, error, isSuccess, isFetching, isLoading, isError, isUninitialized } =
    useGetUserQuery();

  return adaptRequestResponse({
    data: currentData,
    error,
    isSuccess,
    isFetching,
    isLoading,
    isUninitialized,
    isError,
  });
};

export { useUserQuery };
